import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chart-pie-2', 'ChartPie2', [["path",{"d":"M12 3v9h9"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"}]]);